import React from "react";
import WordCloudComponent from "../commons/WordCloudComponent";

function MultipleOpenChartComponent(props) {

    const generateWorldCloudsArray = () => {
        const {questionData, questionAnswers} = props;

        const toReturn = questionData.question.selects.map((element, index) => {
            return (
                <React.Fragment>
                    <p className="multiple__open__title">{element.id}. {element.label}</p>
                    <WordCloudComponent key={"world_cloud_multipleOpen_" + element.id + "_index_" + index}
                                        chartConfig={props.configuration}
                                        isMobile={props.isMobile}
                                        chartIndex={props.chartIndex}
                                        selectIndex={index}
                                        updateChartInfo={props.updateChartInfo}
                                        questionTitle={questionData.question.id + ". " + questionData.question.question}
                                        questionSubtitle={(element.id + ". " + element.label)}
                                        answersData={questionAnswers[element.id]}
                                        questionId={element.id}/>

                </React.Fragment>
            );
        });

        return toReturn;
    };

    return (
        <div onClick={props.onChartContainerClick} className="questionaire__reports__container__content" style={props.chartContainerCss}>
            {props.questionAnswers && generateWorldCloudsArray()}
        </div>
    );
}

export default MultipleOpenChartComponent;